module.exports = __webpack_public_path__ + "static/media/Los_Angeles_Image_-_rounded_corners.4e8c31fd.png";